var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMycar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 12"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "place_homepage_mycar_logo",
    x1: 11.7,
    y1: 1089.7,
    x2: 0,
    y2: 1078,
    gradientTransform: "translate(0 -1078)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0080e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0af"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "place_homepage_mycar_text",
    d: "M50.6 9.1l-1.4-2.4s1.1-.5 1.1-1.9-.2-1.2-.7-1.6-1-.7-1.7-.7h-3.3v6.6h1.8V7h1.1l1.1 2.1h2zm-2.8-5c.2 0 .4 0 .5.2 0 0 .2.3.2.5s0 .3-.2.5c0 0-.3.2-.5.2h-1.4V4.2h1.4zm-7.9 2.2l.6-1.9.6 1.9h-1.3.1zm2.2 2.8H44l-2.5-6.6h-2L37 9.1h1.9l.5-1.4h2.2l.5 1.4zm-8.1.2c-1 0-1.9-.3-2.6-1s-1.1-1.5-1.1-2.5.4-1.8 1.1-2.5c.7-.7 1.6-1 2.6-1 1.9 0 2.8 1.3 2.8 1.3l-1.1 1.1s-.6-.8-1.7-.8-1 .2-1.4.5c-.4.4-.5.8-.5 1.3s.2 1 .5 1.4c.4.4.8.5 1.4.5 1.2 0 1.8-.9 1.8-.9l1 1.1s-.9 1.3-2.8 1.3m-4.6-6.6L27 6.8v2.4h-1.8V6.8l-2.4-4.3h1.9L26 5.1l1.3-2.6h2.1zM16.7 5.2v3.9h-1.8V2.5h1.6l2 2.6 2-2.6h1.6v6.6h-1.8V5.2l-1.8 2.3-1.8-2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#place_homepage_mycar_logo)",
    d: "M0 0v11.7h11.7V0H0zm8.6 8.5H6.9l-2-2.9v2.9H3.1V3.1h1.7l2 2.9V3.1h1.8v5.4z"
  })));
}
export default SvgLogoMycar;